module.exports = __webpack_public_path__ + "static/omid-as-pershing-0136edecf507d63a3458eaf845433eb1.jpg";